import React from "react"

import Layout from '@components/Layout';
import SEO from '@components/SEO';
import RegisterForm from '@components/RegisterForm';
import { graphql } from 'gatsby';

export default ({ data: { accountType } })  => {
    return <Layout>
        <SEO title={'Dealer Sign-up'} />
        <RegisterForm accountType={accountType}/>
    </Layout>
}

export const query = graphql`
    query {
        accountType: merlinAccountType(_id: { eq: "5ef4b6c2553684d6fff90039" }) {
            merlinId
            name
            _id
            customFields {
                _id
                id
                label
                type
                hint
                optional
                multiple
                options {
                    _id
                    label
                }
                items {
                    _id
                    label
                    type
                    hint
                    id
                    multiple
                    disabled
                    options {
                        _id
                        label
                    }
                }
            }
        }
    }
`;
